<section *ngIf="howItWorksOpen" class="popup-overlayHP">
  <div class="popupHP">
    <div class="popupHP__content">
      <!-- <youtube-player [playerVars]="playerConfig" videoId="XIuvoSn9fD8"></youtube-player> -->
      <video #ytvid class="popupHP__video" controls src="../../../../assets/video/how-vervendo-works.mp4"></video>
      <!--<a (click)="howItWorksOpen = !howItWorksOpen;" class="popupHP__cta">Okay, cool!</a>-->
    </div>
  </div>
</section>
<div [style]="'--opacity-on-page:' + opacityOnPage" class="center newSearchContainer">
  <div class="sliderr" data-pos="0">
    <div *ngIf="currentPage > 0" class="sliderr__header flex jc-c">
      <h2>Create your Request!</h2>
    </div>
    <div *ngIf="currentPage === 0" class="sliderr__header flex flex-col jc-c ai-c">
      <h1>Travel to Crete</h1>
    </div>
    <div class="sliderr__lines">
      <div id="line-0" class="line-1 bullet_active">
        <div class="big_line"></div><span>Welcome</span>
      </div>
      <div id="line-1" class="line-2">
        <div class="big_line"></div><span>Destination</span>
      </div>
      <div id="line-2" class="line-3">
        <div class="big_line"></div><span>Property</span>
      </div>
      <div id="line-3" class="line-4">
        <div class="big_line"></div><span>Dates</span>
      </div>
      <div id="line-4" class="line-5">
        <div class="big_line"></div><span>People</span>
      </div>
      <div id="line-5" class="line-6">
        <div class="big_line"></div><span>Budget</span>
      </div>
      <div id="line-6" class="line-7">
        <div class="big_line"></div><span>Experiences</span>
      </div>
      <div id="line-7" class="line-8"><span>Extras</span></div>
    </div>
    <div class="sliderr__slides">
      <div class="sliderr__slide" id="screenIntro">
        <div class="sliderr__body flex flex-col gap-3 ai-c jc-c">
          <!-- <div class="sliderr__text">
            <p>Make your dream vacation to Greece a reality with our innovative booking platform.</p>
            <p>Let our hosts know what you are looking for, then sit back and relax while their exclusive offers roll
              in!
            </p>
          </div> -->
          <a #toggleHowItWorks (click)="showHowItWorks();">Watch How Vervendo Works</a>
          <div class="sliderr__input">
            <button *ngIf="currentPage === 0" (click)="nextSlide('left')">
              I am ready!
            </button>
          </div>
        </div>
      </div>
      <div class="sliderr__slide" id="screen4">
        <div class="sliderr__body flex flex-col gap-3 ai-c jc-c">
          <h3 class="sliderr__title">Where in Crete do you want to go?</h3>
          <h6 class="sliderr__caption">select at least one location</h6>
          <div id="required-where" class="province-labels">
            <button class="sliderr__input-btn" (click)="addLocation('Chania')" id="ChaniaLbl">
              Chania
            </button>
            <button class="sliderr__input-btn" (click)="addLocation('Rethymno')" id="RethymnoLbl">
              Rethymno
            </button>
            <button class="sliderr__input-btn" (click)="addLocation('Iraklio')" id="IraklioLbl">
              Heraklion
            </button>
            <button class="sliderr__input-btn" (click)="addLocation('Agios Nikolaos')" id="Agios NikolaosLbl">
              Agios Nikolaos
            </button>
          </div>
          <svg class="creteSvg" width="286" height="102" viewBox="0 0 286 102" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0)" filter="url(#filter0_d)">
              <path id="Chania" (click)="addLocation('Chania')" fill-rule="evenodd" clip-rule="evenodd"
                d="M109.32 50.0812L103.021 56.4465C102.697 56.7764 102.267 56.9781 101.809 57.0152C101.35 57.0522 100.894 56.9221 100.522 56.6484L97.2727 54.3246C96.3416 53.3914 95.0849 52.8652 93.7735 52.8596H84.6756C83.3642 52.8652 82.1075 53.3914 81.1764 54.3246L70.1539 65.4639C69.6883 65.9305 69.06 66.1935 68.4043 66.1963H66.1048C65.783 66.2001 65.4638 66.137 65.1672 66.011C64.8705 65.885 64.6027 65.6988 64.3802 65.4639L59.6812 60.6141C58.7501 59.6808 57.4934 59.1548 56.182 59.1492H18.0156C17.3721 59.1466 16.7543 58.8932 16.291 58.4419L13.5166 55.6129C13.0608 55.1486 12.801 54.5239 12.7917 53.87V40.5838C12.7917 37.8811 16.5909 33.7134 16.5909 32.3747V19.3916C16.5982 19.0591 16.7326 18.7423 16.9658 18.5076L17.1908 18.2802C17.6557 18.0427 18.1694 17.919 18.6904 17.919C19.2114 17.919 19.7251 18.0427 20.1901 18.2802L24.4141 24.0646C25.3452 24.9979 26.6019 25.5241 27.9133 25.5296H28.0633C28.6335 25.5271 29.1947 25.3856 29.6994 25.1174C30.2041 24.8492 30.6374 24.462 30.9627 23.9887C31.3768 23.4843 31.682 22.8979 31.8585 22.2671C32.035 21.6364 32.0789 20.9753 31.9874 20.3263L31.8375 9.31336C31.8251 9.14124 31.85 8.96847 31.9104 8.80707C31.9708 8.64566 32.0654 8.4995 32.1874 8.37879C32.4301 8.14363 32.751 8.00861 33.0872 8C35.1574 8.40692 37.092 9.33655 38.7109 10.7026C39.1667 11.1668 39.4265 11.7916 39.4357 12.4454V15.906C39.4357 17.2458 39.9624 18.5307 40.8999 19.4781C41.8373 20.4255 43.1088 20.9578 44.4346 20.9578H60.2561L54.6823 15.3755C54.2416 14.9136 53.9914 14.2995 53.9825 13.658V11.4857C53.9825 10.8158 54.2458 10.1732 54.7146 9.69955C55.1833 9.22585 55.819 8.95985 56.4819 8.95985H61.8557C62.5114 8.96264 63.1398 9.22566 63.6053 9.6923L90.8242 35.9614C91.7553 36.8947 93.012 37.4209 94.3234 37.4265H107.97C108.222 37.4264 108.471 37.4769 108.703 37.5749C108.935 37.673 109.146 37.8167 109.322 37.9977C109.499 38.1786 109.639 38.3931 109.733 38.629C109.827 38.8648 109.873 39.1172 109.87 39.3715V48.6667C109.877 48.9277 109.832 49.1874 109.737 49.4304C109.643 49.6735 109.501 49.8948 109.32 50.0812Z"
                fill="#A8C7E4" />
              <path id="Rethymno" (click)="addLocation('Rethymno')" fill-rule="evenodd" clip-rule="evenodd"
                d="M158.384 51.9757L146.662 63.8474C146.439 64.0572 146.262 64.3114 146.141 64.594C146.021 64.8766 145.96 65.1814 145.962 65.4891V83.6755C145.965 83.9397 145.916 84.2019 145.819 84.447C145.721 84.692 145.576 84.915 145.392 85.1029C145.209 85.2909 144.99 85.4402 144.749 85.542C144.507 85.6439 144.249 85.6962 143.987 85.6962H129.665C129.003 85.6962 128.367 85.4302 127.898 84.9565C127.429 84.4828 127.166 83.8402 127.166 83.1703V78.1185C127.162 77.3527 126.979 76.5987 126.632 75.9182C126.284 75.2377 125.782 74.6501 125.166 74.2034L107.87 61.7761C107.639 61.6153 107.446 61.4048 107.305 61.1596C107.164 60.9144 107.078 60.6407 107.055 60.3581C107.031 60.0755 107.069 59.7911 107.167 59.5253C107.265 59.2594 107.42 59.019 107.62 58.8209L114.319 52.0515C114.672 51.6873 114.87 51.1974 114.869 50.6874V39.3209C114.869 38.8051 115.072 38.3105 115.432 37.9458C115.793 37.581 116.283 37.3761 116.793 37.3761H120.568C121.879 37.3705 123.136 36.8443 124.067 35.9111L139.063 20.7557C139.529 20.2891 140.157 20.0259 140.813 20.0231H158.009C158.148 20.0197 158.286 20.0447 158.415 20.0968C158.544 20.1489 158.661 20.227 158.759 20.3262C158.857 20.4254 158.934 20.5438 158.986 20.674C159.037 20.8043 159.062 20.9439 159.059 21.0841V50.2075C159.077 50.5338 159.026 50.8603 158.91 51.1652C158.794 51.4701 158.614 51.7464 158.384 51.9757Z"
                fill="#A8C7E4" />
              <path id="Iraklio" (click)="addLocation('Iraklio')" fill-rule="evenodd" clip-rule="evenodd"
                d="M223.844 48.6667L214.946 57.6589C214.766 57.8364 214.622 58.0483 214.523 58.2825C214.424 58.5167 214.373 58.7683 214.371 59.0228V68.7476C214.375 69.0117 214.326 69.2738 214.228 69.5189C214.131 69.7639 213.986 69.9869 213.802 70.1749C213.618 70.3628 213.399 70.5121 213.158 70.6139C212.917 70.7158 212.658 70.7683 212.397 70.7682H169.656C168.336 70.7672 167.069 71.2939 166.132 72.2333L155.61 84.8627C155.15 85.3233 154.532 85.5858 153.885 85.5952H151.061V67.6109C151.06 67.3056 151.119 67.0032 151.235 66.7213C151.35 66.4395 151.521 66.1837 151.735 65.969L163.483 54.0722C163.701 53.8545 163.873 53.5946 163.989 53.3081C164.104 53.0217 164.162 52.7145 164.158 52.405V21.1851C164.158 20.9037 164.268 20.6339 164.465 20.4349C164.662 20.236 164.929 20.1243 165.207 20.1243H167.707C168.363 20.1271 168.991 20.3901 169.456 20.8567L179.454 30.9603C180.385 31.8935 181.642 32.4197 182.953 32.4253H217.346C217.998 32.4214 218.626 32.6751 219.095 33.1325L223.494 37.6034C223.95 38.0676 224.21 38.6924 224.219 39.3462V47.3028C224.253 47.544 224.237 47.7896 224.173 48.0243C224.108 48.259 223.996 48.4778 223.844 48.6667Z"
                fill="#A8C7E4" />
              <path id="Agios Nikolaos" (click)="addLocation('Agios Nikolaos')" fill-rule="evenodd" clip-rule="evenodd"
                d="M273.208 34.7743V50.7885C273.211 51.215 273.099 51.634 272.883 52.0009L259.236 69.9852C259.029 70.2624 258.761 70.4867 258.453 70.6402C258.145 70.7938 257.805 70.8721 257.462 70.8692H221.37C221.107 70.8692 220.847 70.817 220.605 70.7155C220.362 70.6139 220.142 70.465 219.956 70.2773C219.77 70.0897 219.623 69.867 219.523 69.6218C219.422 69.3766 219.37 69.1139 219.37 68.8485V61.2708C219.371 60.7686 219.569 60.2871 219.92 59.9322L227.144 52.4555C227.32 52.2775 227.531 52.1383 227.763 52.047C227.996 51.9557 228.244 51.9141 228.493 51.925L232.792 52.1271C234.104 52.1216 235.36 51.5954 236.292 50.6621L237.991 48.9445C238.451 48.4839 239.069 48.2214 239.716 48.212H241.49C241.812 48.2083 242.131 48.2714 242.428 48.3974C242.725 48.5234 242.992 48.7096 243.215 48.9445L248.064 53.8194C249.001 54.7589 250.268 55.2856 251.588 55.2845H252.938C254.249 55.2789 255.506 54.7527 256.437 53.8194L261.961 48.2373C262.426 47.7772 262.794 47.2268 263.043 46.619C263.293 46.0113 263.417 45.3588 263.41 44.701V40.1292C263.413 39.4665 263.674 38.8315 264.135 38.361L269.834 32.6021C269.95 32.4801 270.09 32.3834 270.245 32.3183C270.4 32.2531 270.566 32.2207 270.734 32.2232C271.062 32.2265 271.386 32.2951 271.688 32.4251C271.99 32.5551 272.264 32.744 272.494 32.9809C272.724 33.2178 272.905 33.4981 273.028 33.8058C273.15 34.1136 273.212 34.4426 273.208 34.7743Z"
                fill="#A8C7E4" />
            </g>
            <defs>
              <filter id="filter0_d" x="0.791748" y="0" width="284.416" height="101.696" filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha" />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="6" />
                <feColorMatrix type="matrix"
                  values="0 0 0 0 0.0627451 0 0 0 0 0.254902 0 0 0 0 0.435294 0 0 0 0.25 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
              </filter>
              <clipPath id="clip0">
                <rect width="260.416" height="77.6962" fill="white" transform="translate(12.7917 8)" />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>

      <div class="sliderr__slide">
        <div class="sliderr__body flex flex-col ai-c gap-3">
          <h3 class="sliderr__title">What type of accommodation you prefer?</h3>
          <div id="required-accomtype" class="flex ai-c gap-1 accomOpt">
            <div id="villaOpt" (click)="chooseAccomType(0)" class="card__option flex ai-c jc-c">
              <img src="../../../../assets/img/icons/villa.svg" alt="Summer Villa Icon" />
            </div>
            <div id="apartOpt" (click)="chooseAccomType(1)" class="card__option flex ai-c jc-c">
              <img src="../../../../assets/img/icons/apts.svg" alt="Summer Apartments Icon" />
            </div>
          </div>
        </div>

        <!-- <button class="sliderr__next" aria-label="next" (click)="nextSlide('left')">
          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" role="img"
            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
            <path fill="#fff"
              d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z">
            </path>
          </svg>
        </button>

        <button class="sliderr__back" aria-label="back" (click)="nextSlide('right')">
          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" role="img"
            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
            <path fill="#fff"
              d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z">
            </path>
          </svg>
        </button> -->
      </div>

      <div class="sliderr__slide">
        <div class="sliderr__body flex flex-col gap-3">
          <h3 class="sliderr__title">When is this trip planned for?</h3>
          <div class="flex flex-col ai-c gap-2">
            <div id="required-when" (click)="datepickertoggle()">
              <input class="sliderr__input-btn" #myRangeInput value="{{ checkInString }} -> {{ checkOutString }}"
                name="datepicker" ngbDatepicker container="body" #datepicker="ngbDatepicker" [autoClose]="'outside'"
                (dateSelect)="onDateSelection($event)" [displayMonths]="2" [dayTemplate]="t" [minDate]="minDate"
                outsideDays="hidden" [readonly]="true" />
              <ng-template #t let-date let-focused="focused">
                <span class="custom-day" [class.disabled]="isDateDisabled(date)" [class.focused]="focused"
                  [class.range]="isRange(date)" [class.faded]="isHovered(date) || isInside(date)"
                  (mouseenter)="hoveredDate = date" (mouseleave)="hoveredDate = null">
                  {{ date.day }}
                </span>
              </ng-template>
            </div>
            <p class="sliderr__caption">
              Staying for
              <span class="sliderr__counter">{{ nights }}</span>
              night(s).
            </p>
          </div>
        </div>

        <!-- <button class="sliderr__next" aria-label="next" (click)="nextSlide('left')">
          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" role="img"
            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
            <path fill="#fff"
              d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z">
            </path>
          </svg>
        </button>

        <button class="sliderr__back" aria-label="back" (click)="nextSlide('right')">
          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" role="img"
            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
            <path fill="#fff"
              d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z">
            </path>
          </svg>
        </button> -->
      </div>

      <div class="sliderr__slide">

        <div class="sliderr__body flex flex-col gap-3">
          <h3 class="sliderr__title">Who's coming along on this trip?</h3>
          <div class="card__content">
            <div (click)="openRoomsModal()" class="sliderr__input-btn pos-rel">

              <div class="playwithme flex jc-sb ai-c gap-05">

                <span>Adults</span>
                <span class="sliderr__input-btn--bold">{{ roomModalAdults }}</span>
                <span>Children</span>
                <span class="sliderr__input-btn--bold">{{ roomModalChildren }}</span>
                <span>Rooms</span>
                <span class="sliderr__input-btn--bold roomPMobile">{{ roomModalRooms }}</span>

              </div>
            </div>
            <div [ngClass]="{ whoModalMobile: true, show: toShowRoomOptions }">
              <div class="flex__container --row-space-between">
                <div class="select__container">
                  <div class="selectOptions">
                    <select [value]="whoSelection" (change)="roomSelected()" name="roomsSelect" id="room"
                      class="room-control" [(ngModel)]="whoSelection">
                      <option *ngFor="let roomOpt of allRoomOptions" [value]="roomOpt.number">
                        {{ roomOpt.number }} rooms
                      </option>
                    </select>
                  </div>
                </div>
                <div>
                  <button (click)="submitRoomsModal()" class="button--done">
                    Done
                  </button>
                </div>
              </div>
              <div class="whoModalDynamic">
                <div class="roomOptContainer">
                  <div class="roomNumberOpt">
                    <p class="allowWhiteSpace">Room 1</p>
                  </div>
                  <div class="select__container">
                    <p class="select__text">Adults:</p>
                  </div>
                  <select [value]="adultsSelection" name="adultsSelect" id="adult" class="room-control"
                    [(ngModel)]="adultsSelection" (change)="updateWhoModal()">
                    <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                      {{ roomOpt.number }}
                    </option>
                  </select>
                  <div style="display: inline-block" class="roomChildrenOpt">
                    <p class="select__text">Children:</p>
                  </div>
                  <select [value]="childrenSelection" name="childrenSelect" id="child" class="room-control"
                    [(ngModel)]="childrenSelection" (change)="updateWhoModal()">
                    <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                      {{ roomOpt.number }}
                    </option>
                  </select>
                </div>
                <div class="roomOptContainer hidden" id="roomOptContainer2">
                  <div class="roomNumberOpt">
                    <p class="allowWhiteSpace">Room 2</p>
                  </div>
                  <div class="select__container">
                    <p class="select__text">Adults:</p>
                  </div>
                  <select [value]="adultsSelection2" name="adultsSelect" id="adult" class="room-control"
                    [(ngModel)]="adultsSelection2">
                    <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                      {{ roomOpt.number }}
                    </option>
                  </select>
                  <div style="display: inline-block" class="roomChildrenOpt">
                    <p class="select__text">Children:</p>
                  </div>
                  <select [value]="childrenSelection2" name="childrenSelect" id="child" class="room-control"
                    [(ngModel)]="childrenSelection2">
                    <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                      {{ roomOpt.number }}
                    </option>
                  </select>
                </div>
                <div class="roomOptContainer hidden" id="roomOptContainer3">
                  <div class="roomNumberOpt">
                    <p class="allowWhiteSpace">Room 3</p>
                  </div>
                  <div class="select__container">
                    <p class="select__text">Adults:</p>
                  </div>
                  <select [value]="adultsSelection3" name="adultsSelect" id="adult" class="room-control"
                    [(ngModel)]="adultsSelection3">
                    <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                      {{ roomOpt.number }}
                    </option>
                  </select>
                  <div style="display: inline-block" class="roomChildrenOpt">
                    <p class="select__text">Children:</p>
                  </div>
                  <select [value]="childrenSelection3" name="childrenSelect" id="child" class="room-control"
                    [(ngModel)]="childrenSelection3">
                    <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                      {{ roomOpt.number }}
                    </option>
                  </select>
                </div>
                <div class="roomOptContainer hidden" id="roomOptContainer4">
                  <div class="roomNumberOpt">
                    <p class="allowWhiteSpace">Room 4</p>
                  </div>
                  <div class="select__container">
                    <p class="select__text">Adults:</p>
                  </div>
                  <select [value]="adultsSelection4" name="adultsSelect" id="adult" class="room-control"
                    [(ngModel)]="adultsSelection4">
                    <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                      {{ roomOpt.number }}
                    </option>
                  </select>
                  <div style="display: inline-block" class="roomChildrenOpt">
                    <p class="select__text">Children:</p>
                  </div>
                  <select [value]="childrenSelection4" name="childrenSelect" id="child" class="room-control"
                    [(ngModel)]="childrenSelection4">
                    <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                      {{ roomOpt.number }}
                    </option>
                  </select>
                </div>
                <div class="roomOptContainer hidden" id="roomOptContainer5">
                  <div class="roomNumberOpt">
                    <p class="allowWhiteSpace">Room 5</p>
                  </div>
                  <div class="select__container">
                    <p class="select__text">Adults:</p>
                  </div>
                  <select [value]="adultsSelection5" name="adultsSelect" id="adult" class="room-control"
                    [(ngModel)]="adultsSelection5">
                    <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                      {{ roomOpt.number }}
                    </option>
                  </select>
                  <div style="display: inline-block" class="roomChildrenOpt">
                    <p class="select__text">Children:</p>
                  </div>
                  <select [value]="childrenSelection5" name="childrenSelect" id="child" class="room-control"
                    [(ngModel)]="childrenSelection5">
                    <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                      {{ roomOpt.number }}
                    </option>
                  </select>
                </div>
                <div class="roomOptContainer hidden" id="roomOptContainer6">
                  <div class="roomNumberOpt">
                    <p class="allowWhiteSpace">Room 6</p>
                  </div>
                  <div class="select__container">
                    <p class="select__text">Adults:</p>
                  </div>
                  <select [value]="adultsSelection6" name="adultsSelect" id="adult" class="room-control"
                    [(ngModel)]="adultsSelection6">
                    <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                      {{ roomOpt.number }}
                    </option>
                  </select>
                  <div style="display: inline-block" class="roomChildrenOpt">
                    <p class="select__text">Children:</p>
                  </div>
                  <select [value]="childrenSelection6" name="childrenSelect" id="child" class="room-control"
                    [(ngModel)]="childrenSelection6">
                    <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                      {{ roomOpt.number }}
                    </option>
                  </select>
                </div>
                <div class="roomOptContainer hidden" id="roomOptContainer7">
                  <div class="roomNumberOpt">
                    <p class="allowWhiteSpace">Room 7</p>
                  </div>
                  <div class="select__container">
                    <p class="select__text">Adults:</p>
                  </div>
                  <select [value]="adultsSelection7" name="adultsSelect" id="adult" class="room-control"
                    [(ngModel)]="adultsSelection7">
                    <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                      {{ roomOpt.number }}
                    </option>
                  </select>
                  <div style="display: inline-block" class="roomChildrenOpt">
                    <p class="select__text">Children:</p>
                  </div>
                  <select [value]="childrenSelection7" name="childrenSelect" id="child" class="room-control"
                    [(ngModel)]="childrenSelection7">
                    <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                      {{ roomOpt.number }}
                    </option>
                  </select>
                </div>
                <div class="roomOptContainer hidden" id="roomOptContainer8">
                  <div class="roomNumberOpt">
                    <p class="allowWhiteSpace">Room 8</p>
                  </div>
                  <div class="select__container">
                    <p class="select__text">Adults:</p>
                  </div>
                  <select [value]="adultsSelection8" name="adultsSelect" id="adult" class="room-control"
                    [(ngModel)]="adultsSelection8">
                    <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                      {{ roomOpt.number }}
                    </option>
                  </select>
                  <div style="display: inline-block" class="roomChildrenOpt">
                    <p class="select__text">Children:</p>
                  </div>
                  <select [value]="childrenSelection8" name="childrenSelect" id="child" class="room-control"
                    [(ngModel)]="childrenSelection8">
                    <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                      {{ roomOpt.number }}
                    </option>
                  </select>
                </div>
                <div class="roomOptContainer hidden" id="roomOptContainer9">
                  <div class="roomNumberOpt">
                    <p class="allowWhiteSpace">Room 9</p>
                  </div>
                  <div class="select__container">
                    <p class="select__text">Adults:</p>
                  </div>
                  <select [value]="adultsSelection9" name="adultsSelect" id="adult" class="room-control"
                    [(ngModel)]="adultsSelection9">
                    <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                      {{ roomOpt.number }}
                    </option>
                  </select>
                  <div style="display: inline-block" class="roomChildrenOpt">
                    <p class="select__text">Children:</p>
                  </div>
                  <select [value]="childrenSelection9" name="childrenSelect" id="child" class="room-control"
                    [(ngModel)]="childrenSelection9">
                    <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                      {{ roomOpt.number }}
                    </option>
                  </select>
                </div>
                <div class="roomOptContainer hidden" id="roomOptContainer10">
                  <div class="roomNumberOpt">
                    <p class="allowWhiteSpace">Room 10</p>
                  </div>
                  <div class="select__container">
                    <p class="select__text">Adults:</p>
                  </div>
                  <select [value]="adultsSelection10" name="adultsSelect" id="adult" class="room-control"
                    [(ngModel)]="adultsSelection10">
                    <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                      {{ roomOpt.number }}
                    </option>
                  </select>
                  <div style="display: inline-block" class="roomChildrenOpt">
                    <p class="select__text">Children:</p>
                  </div>
                  <select [value]="childrenSelection10" name="childrenSelect" id="child" class="room-control"
                    [(ngModel)]="childrenSelection10">
                    <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                      {{ roomOpt.number }}
                    </option>
                  </select>
                </div>
              </div>
              <!--<div (click)="submitRoomsModal()" class="submitModalMobile"></div>-->
            </div>
          </div>

          <!-- <button class="sliderr__next" aria-label="next" (click)="nextSlide('left')">
          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" role="img"
            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
            <path fill="#fff"
              d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z">
            </path>
          </svg>
        </button>

        <button class="sliderr__back" aria-label="back" (click)="nextSlide('right')">
          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" role="img"
            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
            <path fill="#fff"
              d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z">
            </path>
          </svg>
        </button> -->
        </div>

      </div>

      <div class="sliderr__slide">

        <div class="sliderr__body flex flex-col gap-3">
          <h3 class="sliderr__title">Will you be on a daily budget?</h3>
          <div class="custom-slider flex">
            <ngx-slider [(value)]="value" [options]="options"></ngx-slider>
          </div>
        </div>

        <!-- <button class="sliderr__next" aria-label="next" (click)="nextSlide('left')">
          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" role="img"
            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
            <path fill="#fff"
              d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z">
            </path>
          </svg>
        </button>

        <button class="sliderr__back" aria-label="back" (click)="nextSlide('right')">
          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" role="img"
            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
            <path fill="#fff"
              d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z">
            </path>
          </svg>
        </button> -->
      </div>

      <div class="sliderr__slide">
        <div class="sliderr__body">
          <h3 class="sliderr__title">What would you wish to experience?</h3>
          <p class="sliderr__caption">Choose up to 3 experiences</p>
          <p class="sliderr__exp-max"
            [ngStyle]="currentSelectedExp === 3 ? {'visibility':'visible', 'opacity':'1'} : {'visibility':'hidden', 'opacity':'0'}">
            You have selected all your experiences</p>
          <div class="sliderr__exp-grid">
            <button *ngFor="let exp of experiencesMappingRest; let i = index"
              (click)="addExpToList(exp.id, exp.checked, exp.position)" class="sliderr__exp-btn" id="{{ exp.id }}"
              mat-raised-button><img [src]="exp.iconUrl" />
              {{ exp.name }}
            </button>
          </div>
        </div>

        <!-- <button class="sliderr__next" aria-label="next" (click)="nextSlide('left')">
          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" role="img"
            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
            <path fill="#fff"
              d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z">
            </path>
          </svg>
        </button>

        <button class="sliderr__back" aria-label="back" (click)="nextSlide('right')">
          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" role="img"
            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
            <path fill="#fff"
              d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z">
            </path>
          </svg>
        </button> -->
      </div>

      <div class="sliderr__slide">


        <div class="sliderr__body flex flex-col gap-3">
          <h3 class="sliderr__title">Anything more specific you want to add?</h3>
          <div class="flex jc-c">
            <textarea [(ngModel)]="personalRequestText" class="sliderr__textarea" id="personalRequest"
              maxlength="{{ personalRequestMaxLength }}"
              placeholder="Describe your needs to receive better offers."></textarea>
          </div>
        </div>


        <div class="sliderr__input flex jc-c ai-c">
          <input *ngIf="!isLoggedIn" type="email" name="email" id="email" placeholder="example@mail.com*" />
          <button [ngStyle]="
              isLoggedIn ? { 'margin-left': '0' } : { 'margin-left': '-3rem' }
            " [disabled]="requestButtonDisabled" (click)="loginAndSendRequest()">
            I'm ready!
          </button>
        </div>

        <div *ngIf="isLoggedIn" class="sliderr__note">
          <span>Note: Your email is required for the hosts to respond.</span>
        </div>

      </div>
    </div>

    <button *ngIf="currentPage < 7 && currentPage !== 0" class="sliderr__next sliderr__next--active" aria-label="next"
      (click)="nextSlide('left')">
      <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" role="img"
        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
        <path fill="#fff"
          d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z">
        </path>
      </svg>
    </button>

    <button *ngIf="currentPage > 0" class="sliderr__back sliderr__back--active" aria-label="back"
      (click)="nextSlide('right')">
      <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" role="img"
        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
        <path fill="#fff"
          d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z">
        </path>
      </svg>
    </button>

    <div class="sliderr__dots" id="sliderr__dotsAll">
      <p class="sliderr__indicator"></p>
      <div class="dot-outline">
        <p id="page0" class="sliderr__dot" data-pos="0"></p>
      </div>
      <p class="line"></p>
      <div class="dot-outline">
        <p id="page1" class="sliderr__dot" data-pos="1"></p>
      </div>
      <p class="line"></p>
      <div class="dot-outline">
        <p id="page2" class="sliderr__dot" data-pos="2"></p>
      </div>
      <p class="line"></p>
      <div class="dot-outline">
        <p id="page3" class="sliderr__dot" data-pos="3"></p>
      </div>
      <p class="line"></p>
      <div class="dot-outline">
        <p id="page4" class="sliderr__dot" data-pos="4"></p>
      </div>
      <p class="line"></p>
      <div class="dot-outline">
        <p id="page5" class="sliderr__dot" data-pos="5"></p>
      </div>
      <p class="line"></p>
      <div class="dot-outline">
        <p id="page6" class="sliderr__dot" data-pos="6"></p>
      </div>
      <div class="dot-outline">
        <p id="page7" class="sliderr__dot" data-pos="7"></p>
      </div>
    </div>
  </div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>